export default __webpack_public_path__ + "static/meet-john-10-8d752ccafb5894b2ddd993310ac95577.webp";